
import React, { useEffect } from 'react';
import SpecteraFormButton from '../SpecteraFormButton';

import { Field, FormSection, formValueSelector } from 'redux-form';

import {
  AutoCompleteSelect,
  InputWithIcon,
  RadioGroup
} from '../../../../../../../../../itrust_common/components/form';

import { connect, useDispatch } from 'react-redux';

import {
  specteraLensesConfigurationsLoad
} from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/spectera/specteraAction';

function SpecteraStep2(props) {
  const {
    claimFormTemplate,
    visionInsuranceClaimForm,
    specteraAddOn,
    patientKnownToHaveDiabetes,
    patientReferredToPcp,
    contactFitProcedureCode,
    isMedicalEval,
    primaryDiagnosisCode,
    diagnosisCode2,
    diagnosisCode3,
    diagnosisCode4,
    diagnosisCode5,
    diagnosisCode6,
    diagnosisCode7,
    referralDiagnosisCode,
    procedureCode1,
    procedureCode1Bill,
    patientTestedForGlaucoma,
    diabetesDiagnosisCode,
    cptiiCode,
    contactFitModifier,
    contactFitBill
  } = props;

  const dispatch = useDispatch();

  const selectedLocation =
    specteraAddOn?.config?.locations?.find(
      loc => loc.name === specteraAddOn?.config?.creds?.location
    ) || {};

  const eligibilityData =
    visionInsuranceClaimForm?.eligibility?.data || [];

  const showContactFit =
    eligibilityData.find(
      item => item.service_type === 'Contact Fit'
    )?.active || false;

  const showExam =
    eligibilityData.find(
      item => item.service_type === 'Exam Benefit'
    )?.active || false;

  const examMap =
    claimFormTemplate?.config?.exam?.reduce((acc, item) => {
      acc[item.label] = item;
      return acc;
    }, {}) || {};

  const contactFitMap =
    claimFormTemplate?.config?.contact_lens_fit?.reduce(
      (acc, item) => {
        acc[item.label] = item;
        return acc;
      },
      {}
    ) || {};

  // useEffect(() => {
  //   const isLensBenefit =
  //     eligibilityData.find(
  //       item => item.service_type === 'Lens Benefit'
  //     )?.active || false;

  //   // Load the lens configuration in advance.
  //   if (isLensBenefit) {
  //     dispatch(
  //       specteraLensesConfigurationsLoad(
  //         visionInsuranceClaimForm.id,
  //         {
  //           lens_type: 'os',
  //           location_id: selectedLocation?.id || '',
  //           vision_benefit_id: 2
  //         }
  //       )
  //     );
  //   }
  // }, []);

  const hasValue = value =>
    value !== undefined &&
    value !== null &&
    value !== '';

const isStepComplete =
  hasValue(primaryDiagnosisCode) &&
  hasValue(patientReferredToPcp); 
  const diagnosisOptions = [
    ...(examMap?.primary_diagnosis_code?.options || [])
  ];

  return (
    <div className="bg-white p-6 border rounded">
      <FormSection name="diagnosis">
        <div className="row">
          <h5 className="col-12 mb-5">
            Diagnosis Codes as Indicated (Include all applicable diagnosis codes)
          </h5>

          {/* Diagnosis Code 1: Primary — always enabled */}
          <Field
            name="primary_diagnosis_code"
            valueField="value"
            textField="label"
            data={diagnosisOptions}
            label="Diagnosis Code 1 (Primary)"
            component={AutoCompleteSelect}
            wrapperClasses="col-3 form-group"
          />

          {/* Diagnosis Code 2 — enabled after Primary is selected */}
          <Field
            name="diagnosis_code_2"
            label="Diagnosis Code 2"
            component={AutoCompleteSelect}
            textField="label"
            valueField="value"
            data={diagnosisOptions}
            wrapperClasses="col-3 form-group"
            disabled={!hasValue(primaryDiagnosisCode)}
          />

          {/* Diagnosis Code 3 — enabled after Code 2 is selected */}
          <Field
            name="diagnosis_code_3"
            label="Diagnosis Code 3"
            component={AutoCompleteSelect}
            textField="label"
            valueField="value"
            data={diagnosisOptions}
            wrapperClasses="col-3 form-group"
            disabled={!hasValue(diagnosisCode2)}
          />

          {/* Diagnosis Code 4 — enabled after Code 3 is selected */}
          <Field
            name="diagnosis_code_4"
            label="Diagnosis Code 4"
            component={AutoCompleteSelect}
            textField="label"
            valueField="value"
            data={diagnosisOptions}
            wrapperClasses="col-3 form-group"
            disabled={!hasValue(diagnosisCode3)}
          />

          {/* Diagnosis Code 5 — enabled after Code 4 is selected */}
          <Field
            name="diagnosis_code_5"
            label="Diagnosis Code 5"
            component={AutoCompleteSelect}
            textField="label"
            valueField="value"
            data={diagnosisOptions}
            wrapperClasses="col-3 form-group"
            disabled={!hasValue(diagnosisCode4)}
          />

          {/* Diagnosis Code 6 — enabled after Code 5 is selected */}
          <Field
            name="diagnosis_code_6"
            label="Diagnosis Code 6"
            component={AutoCompleteSelect}
            textField="label"
            valueField="value"
            data={diagnosisOptions}
            wrapperClasses="col-3 form-group"
            disabled={!hasValue(diagnosisCode5)}
          />

          {/* Diagnosis Code 7 — enabled after Code 6 is selected */}
          <Field
            name="diagnosis_code_7"
            label="Diagnosis Code 7"
            component={AutoCompleteSelect}
            textField="label"
            valueField="value"
            data={diagnosisOptions}
            wrapperClasses="col-3 form-group"
            disabled={!hasValue(diagnosisCode6)}
          />

          {/* Diagnosis Code 8 — enabled after Code 7 is selected */}
          <Field
            name="diagnosis_code_8"
            label="Diagnosis Code 8"
            component={AutoCompleteSelect}
            textField="label"
            valueField="value"
            data={diagnosisOptions}
            wrapperClasses="col-3 form-group"
            disabled={!hasValue(diagnosisCode7)}
          />

          <RadioGroup
            name="patient_referred_to_pcp"
            options={[
              { label: 'Yes', value: 'yes' },
              { label: 'No', value: 'no' }
            ]}
            wrapperClasses="col-3 form-group"
            label="Patient referred to their primary care provider:"
          />

          {patientReferredToPcp === 'yes' && (
            <Field
              label="Referral Diagnosis Code"
              name="referral_diagnosis_code"
              component={AutoCompleteSelect}
              textField="label"
              valueField="value"
              data={[
                ...(examMap?.patient_referred_to_pcp
                  ?.visible_when_true?.[0]?.options || [])
              ]}
              wrapperClasses="col-3 form-group"
            />
          )}
        </div>
      </FormSection>

      {showExam && (
        <>
          <hr />

          <FormSection name="exam">
            <div className="row mt-6">
              <h5 className="col-12 mb-5">Exam Benefit</h5>

              <Field
                label="Procedure Code 1"
                name="procedure_code_1"
                component={AutoCompleteSelect}
                textField="label"
                valueField="value"
                data={[
                  ...(examMap?.procedure_code_1?.options || [])
                ]}
                wrapperClasses="col-6 form-group"
              />

              <Field
                name="procedure_code_1_bill"
                component={InputWithIcon}
                title="$"
                className="form-control"
                wrapperClasses="col-2 mt-6 offset-4"
              />

              <Field
                label="Procedure Code 2"
                name="procedure_code_2"
                component={AutoCompleteSelect}
                textField="label"
                valueField="value"
                data={[
                  ...(examMap?.procedure_code_2?.options || [])
                ]}
                wrapperClasses="col-6 form-group"
              />

              <Field
                name="procedure_code_2_bill"
                component={InputWithIcon}
                title="$"
                className="form-control"
                wrapperClasses="col-2 mt-6 offset-4"
              />

              <Field
                label="Procedure Code 3"
                name="procedure_code_3"
                component={AutoCompleteSelect}
                textField="label"
                valueField="value"
                data={[
                  ...(examMap?.procedure_code_3?.options || [])
                ]}
                wrapperClasses="col-6 form-group"
              />

              <Field
                name="procedure_code_3_bill"
                component={InputWithIcon}
                title="$"
                className="form-control"
                wrapperClasses="col-2 mt-6 offset-4"
              />

              {isMedicalEval && (
                <>
                  <RadioGroup
                    name="patient_tested_for_glaucoma"
                    options={[
                      { label: 'Yes', value: 'yes' },
                      { label: 'No', value: 'no' }
                    ]}
                    wrapperClasses="col-6 form-group"
                    label="Patient tested for glaucoma:"
                  />

                  <RadioGroup
                    name="patient_known_to_have_diabetes"
                    options={[
                      { label: 'Yes', value: 'yes' },
                      { label: 'No', value: 'no' }
                    ]}
                    wrapperClasses="col-6 form-group"
                    label="Is the patient known to have diabetes:"
                  />

                  {patientKnownToHaveDiabetes === 'yes' && (
                    <>
                      <Field
                        label="Diabetes Diagnosis Code"
                        name="diabetes_diagnosis_code"
                        component={AutoCompleteSelect}
                        textField="DESCRIPTION"
                        valueField="DIAGNOSIS_CODE"
                        data={[
                          ...(examMap?.patient_known_to_have_diabetes
                            ?.visible_when_true?.find(
                              item =>
                                item.label ===
                                'diabetes_diagnosis_code'
                            )?.options || [])
                        ]}
                        wrapperClasses="col-6 form-group"
                      />

                      <Field
                        label="CPTII"
                        name="cptii_code"
                        component={AutoCompleteSelect}
                        textField="label"
                        valueField="value"
                        data={[
                          ...(examMap?.patient_known_to_have_diabetes
                            ?.visible_when_true?.find(
                              item => item.label === 'cptii_code'
                            )?.options || [])
                        ]}
                        wrapperClasses="col-6 form-group"
                      />
                    </>
                  )}
                </>
              )}
            </div>
          </FormSection>
        </>
      )}

      {showContactFit && (
        <>
          <hr />

          <FormSection name="contact_lens_fit">
            <div className="row mt-6">
              <h5 className="col-12 mb-5">Contact Fit</h5>

              <Field
                label="Procedure Code"
                name="contact_fit_procedure_code"
                component={AutoCompleteSelect}
                textField="label"
                valueField="value"
                data={[
                  ...(contactFitMap?.contact_fit_procedure_code
                    ?.options || [])
                ]}
                wrapperClasses="col-6 form-group"
              />

              <div className="col-4 form-group">
                {contactFitProcedureCode && (
                  <Field
                    label="Modifier"
                    name="contact_fit_modifier"
                    component={AutoCompleteSelect}
                    textField="label"
                    valueField="value"
                    data={[
                      ...(contactFitMap?.contact_fit_modifier
                        ?.options || [])
                    ]}
                  />
                )}
              </div>

              <Field
                name="contact_fit_bill"
                component={InputWithIcon}
                title="$"
                className="form-control"
                wrapperClasses="col-2 mt-6"
                disabled={!contactFitProcedureCode}
              />
            </div>
          </FormSection>
        </>
      )}

      <SpecteraFormButton
        backStep="first"
        disabled={!isStepComplete}
      />
    </div>
  );
}

const selector = formValueSelector('SpecteraClaimForm');

const mapStateToProps = state => {
  const { visionInsurance } = state;

  const patientKnownToHaveDiabetes = selector(
    state,
    'exam.patient_known_to_have_diabetes'
  );

  const contactFitProcedureCode = selector(
    state,
    'contact_lens_fit.contact_fit_procedure_code'
  );

  const patientReferredToPcp = selector(
    state,
    'diagnosis.patient_referred_to_pcp'
  );

  const procedure_code_1 =
    selector(state, 'exam.procedure_code_1') || '';

  const procedure_code_2 =
    selector(state, 'exam.procedure_code_2') || '';

  const procedure_code_3 =
    selector(state, 'exam.procedure_code_3') || '';

  const medicalEvalCodes = [
    '17863',
    '17864',
    '17865',
    '17866'
  ];

  return {
    patientKnownToHaveDiabetes,
    patientReferredToPcp,
    contactFitProcedureCode,

    primaryDiagnosisCode: selector(
      state,
      'diagnosis.primary_diagnosis_code'
    ),

    diagnosisCode2: selector(
      state,
      'diagnosis.diagnosis_code_2'
    ),

    diagnosisCode3: selector(
      state,
      'diagnosis.diagnosis_code_3'
    ),

    diagnosisCode4: selector(
      state,
      'diagnosis.diagnosis_code_4'
    ),

    diagnosisCode5: selector(
      state,
      'diagnosis.diagnosis_code_5'
    ),

    diagnosisCode6: selector(
      state,
      'diagnosis.diagnosis_code_6'
    ),

    diagnosisCode7: selector(
      state,
      'diagnosis.diagnosis_code_7'
    ),

    diagnosisCode8: selector(
      state,
      'diagnosis.diagnosis_code_8'
    ),

    referralDiagnosisCode: selector(
      state,
      'diagnosis.referral_diagnosis_code'
    ),

    procedureCode1: procedure_code_1,

    procedureCode1Bill: selector(
      state,
      'exam.procedure_code_1_bill'
    ),

    patientTestedForGlaucoma: selector(
      state,
      'exam.patient_tested_for_glaucoma'
    ),

    diabetesDiagnosisCode: selector(
      state,
      'exam.diabetes_diagnosis_code'
    ),

    cptiiCode: selector(state, 'exam.cptii_code'),

    contactFitModifier: selector(
      state,
      'contact_lens_fit.contact_fit_modifier'
    ),

    contactFitBill: selector(
      state,
      'contact_lens_fit.contact_fit_bill'
    ),

    isMedicalEval:
      medicalEvalCodes.includes(procedure_code_1) ||
      medicalEvalCodes.includes(procedure_code_2) ||
      medicalEvalCodes.includes(procedure_code_3),

    specteraAddOn:
      visionInsurance?.services?.find(
        item => item.config.service === 'spectera'
      ) || {}
  };
};

export default connect(mapStateToProps)(SpecteraStep2);
